import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FC } from 'react';
import { ReactComponent as Sectors } from "../../../assets/icons/sector.svg";
import theme from "../../../theme";
import KeyPeopleTags from '../../atoms/KeyPeopleTags';

const useStyles = makeStyles(() => ({
    dialog: {
        "& .MuiDialog-paper": {
            width: 'auto',
            maxWidth: '100%',
            minWidth: 450,
            height: 'fit-content',
            minHeight: '30vh',
            maxHeight: '70vh',
            padding: '16px 24px 8px 24px',
            boxShadow: '0px 20px 30px -5px rgba(16, 24, 40, 0.06)',
            borderRadius: 24,
        }
    },
    dialogTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        padding: 'unset',
        color: 'black',
        fontWeight: 'bold',
        fontFamily: 'Inter',
        fontSize: '1.3rem',
        gap: 16,
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        padding: '8px 0',
        height: '100%',
        overflow: 'hidden',
    },
    dialogActions: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    headerIcon: {
        stroke: theme.colors.neutral['500'],
        width: 32,
        height: 32,
    },
    content: {
        padding: '24px',
        width: '100%',
        maxHeight: '500px',
        overflow: 'auto',
    },
    cancelBtn: {
        height: '40px',
        width: '88px',
        padding: '8px 24px',
        borderRadius: '40px',
        backgroundColor: theme.colors.neutral['100'],
        color: theme.colors.neutral['500'],
        textTransform: 'none',
        transition: 'ease-in-out 300ms',
    },
}))

const ManageKeyPeopleTagsModal: FC<{
    open: boolean;
    onClose: () => void;
}> = ({ open, onClose }) => {
    const classes = useStyles();

    return (<>
        <Dialog className={classes.dialog} open={open} onClose={() => onClose()}>
            <DialogTitle className={classes.dialogTitle}>
                <Sectors className={classes.headerIcon} />
                <span>{'Team Tags'}</span>
            </DialogTitle>
            <Divider sx={{ margin: '8px 0', width: '100%' }} />
            <DialogContent className={classes.dialogContent}>
                <Typography color={theme.colors.neutral['600']} pl={1}>
                    {'Tags get automatically assigned using AI to new deals.'}
                </Typography>
                <KeyPeopleTags />
            </DialogContent>
            <Divider sx={{ margin: '8px 0'}} />
            <DialogActions className={classes.dialogActions}>
                <Button className={classes.cancelBtn} onClick={onClose}>
                    {'Back'}
                </Button>
            </DialogActions>
        </Dialog>
    </>);
}

export default ManageKeyPeopleTagsModal;